var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "quote-parts-control-section",
    [
      _c("template", { slot: "heading" }, [
        _c("span", { staticClass: "mt-1" }, [_vm._v(" Not Ordered ")]),
        _c(
          "span",
          { staticClass: "has-text-weight-bold has-text-success ml-5" },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$filters.formatCurrency(
                    _vm.addTotal(_vm.unorderedParts, "buyPrice"),
                    _vm.$userInfo.locale
                  )
                ) +
                " "
            ),
          ]
        ),
      ]),
      _c("template", { slot: "heading_buttons" }, [
        _c(
          "div",
          {
            staticClass: "button ml-2 is-primary",
            class: { "disabled is-outlined": !_vm.unorderedParts?.length },
            on: {
              click: function ($event) {
                return _vm.handleNewPurchaseOrder(_vm.partsControlEnums.newPo)
              },
            },
          },
          [_vm._v(" Purchase Order ")]
        ),
        _c(
          "div",
          {
            staticClass: "button ml-2 is-primary",
            class: { "disabled is-outlined": !_vm.unorderedParts?.length },
            on: {
              click: function ($event) {
                return _vm.handleNewPurchaseOrder(
                  _vm.partsControlEnums.manualQuote
                )
              },
            },
          },
          [_vm._v(" Parts Enquiry ")]
        ),
        _vm.userPartsCheckPermission()
          ? _c(
              "div",
              {
                staticClass: "button ml-2 is-success",
                class: { "is-outlined disabled": _vm.pricePartsDisabled },
                on: {
                  click: function ($event) {
                    return _vm.$emit("goToPriceParts", _vm.unorderedParts)
                  },
                },
              },
              [_vm._v(" Price Parts ")]
            )
          : _vm._e(),
      ]),
      _c("template", { slot: "body" }, [
        _vm.unorderedParts.length
          ? _c("div", { staticClass: "unordered-parts header" }, [
              _c("div", [_vm._v("#")]),
              _c("div", [_vm._v("Reqst.")]),
              _c("div", { staticClass: "left" }, [_vm._v("Description")]),
              _c("div", [_vm._v("Report")]),
              _c("div", [_vm._v("Part No")]),
              _c("div", [_vm._v("Item Type")]),
              _c("div", [_vm._v("Qty")]),
              _c("div", [_vm._v("Supplier")]),
              _c("div", { staticClass: "right" }, [_vm._v("Unit Cost")]),
              _c("div", { staticClass: "right" }, [_vm._v("Unit Sell")]),
              _c("div", [_vm._v(" Status")]),
            ])
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "my-2 part-row is-align-content-center",
                  class: `parts-control-background-${_vm.$theme.name}`,
                },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-grey-light is-size-6 mx-4" },
                    [_vm._v(" No Unordered Parts ")]
                  ),
                ]
              ),
            ]),
        _c(
          "div",
          _vm._l(_vm.unorderedParts, function (item, index) {
            return _c("div", { key: item.quoteItemId }, [
              _c(
                "div",
                {
                  staticClass: "unordered-parts part-row",
                  class: [
                    `parts-control-background-${_vm.$theme.name}`,
                    {
                      "is-editable":
                        item.partStatus ===
                          _vm.PartStatusTypes.sentManualEnquiry ||
                        item.partStatus ===
                          _vm.PartStatusTypes.pricedPartsControlManual,
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.handleSelectRow(item)
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("div", [_c("span", [_vm._v(_vm._s(index + 1))])]),
                  _c("div", [
                    item.partStatus === "Exp" ||
                    item.partStatus === "Imp" ||
                    item.partStatus === "Pord"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-flex-direction-row is-align-content-center is-clickable is-underlined has-text-primary",
                            on: {
                              click: function ($event) {
                                return _vm.goToPartsCheck(
                                  $event,
                                  item?.partsCheckReferenceNo,
                                  "quote",
                                  item
                                )
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("#" + _vm._s(item.partsCheckReferenceNo)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "left" }, [
                    item.quoteItemId === _vm.itemEditingId
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.itemDesc,
                              expression: "item.itemDesc",
                            },
                          ],
                          staticClass: "input focus-target",
                          attrs: {
                            "data-target": "itemDesc",
                            maxlength: 150,
                            title: "Description: " + item.itemDesc,
                            placeholder: "Item Description",
                          },
                          domProps: { value: item.itemDesc },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(item, "itemDesc", $event.target.value)
                            },
                          },
                        })
                      : _c("span", [_vm._v(" " + _vm._s(item.itemDesc) + " ")]),
                  ]),
                  _c("div", [
                    item.reportOnly
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { theme: "secondary", enabled: true },
                                expression:
                                  "{ theme: 'secondary', enabled: true }",
                              },
                            ],
                            staticClass: "tag p-1 px-2",
                            class: item.reportOnly
                              ? "is-dark is-danger"
                              : "is-white",
                            attrs: { content: "Report" },
                          },
                          [_vm._v("R ")]
                        )
                      : _vm._e(),
                  ]),
                  _c("div", [
                    !item.isNew
                      ? _c("span", [_vm._v(" " + _vm._s(item.partNo) + " ")])
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.partNo,
                              expression: "item.partNo",
                            },
                          ],
                          staticClass: "input focus-target mx-1",
                          attrs: {
                            "data-target": "partNo",
                            maxlength: 150,
                            title: "Part No." + item.partNo,
                            placeholder: "Part No.",
                          },
                          domProps: { value: item.partNo },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(item, "partNo", $event.target.value)
                            },
                          },
                        }),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.PartTypes?.[item.mark] || "-")),
                  ]),
                  _c(
                    "div",
                    [
                      item.quoteItemId === _vm.itemEditingId &&
                      item.itemType === "PART"
                        ? _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: { min: 1, precision: 0 },
                            model: {
                              value: item.itemQuantity,
                              callback: function ($$v) {
                                _vm.$set(item, "itemQuantity", _vm._n($$v))
                              },
                              expression: "item.itemQuantity",
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.itemType === "PART"
                                    ? item.itemQuantity -
                                        item.quantityOrdered +
                                        item.quantityReturned
                                    : "N/A"
                                ) +
                                " "
                            ),
                          ]),
                    ],
                    1
                  ),
                  _c("div", [
                    _vm._v(_vm._s(item.vendorName ? item.vendorName : "-")),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      item.quoteItemId === _vm.itemEditingId
                        ? _c("vue-numeric", {
                            staticClass: "input has-text-right ml-3",
                            attrs: {
                              "data-target": "buyPrice",
                              title: "Cost Price: " + item.buyPrice,
                              min: 0,
                              precision: 2,
                            },
                            nativeOn: {
                              input: function ($event) {
                                return _vm.handleOnPriceChange(item)
                              },
                            },
                            model: {
                              value: item.buyPrice,
                              callback: function ($$v) {
                                _vm.$set(item, "buyPrice", _vm._n($$v))
                              },
                              expression: "item.buyPrice",
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    item.buyPrice,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]),
                    ],
                    1
                  ),
                  item.itemType === _vm.ItemCategoryTypes.SUBL
                    ? _c(
                        "div",
                        {
                          staticClass: "right sell-price-field",
                          attrs: { id: item.quoteItemId },
                        },
                        [
                          item.quoteItemId === _vm.itemEditingId
                            ? _c("vue-numeric", {
                                staticClass: "input has-text-right ml-3",
                                attrs: {
                                  "data-target": "value",
                                  title: "Sell Price: " + item.value,
                                  min: 0,
                                  precision: 2,
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    return _vm.handleOnPriceChange(item)
                                  },
                                },
                                model: {
                                  value: item.value,
                                  callback: function ($$v) {
                                    _vm.$set(item, "value", _vm._n($$v))
                                  },
                                  expression: "item.value",
                                },
                              })
                            : _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        item.value,
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "right sell-price-field",
                          attrs: { id: item.quoteItemId },
                        },
                        [
                          item.quoteItemId === _vm.itemEditingId
                            ? _c("vue-numeric", {
                                staticClass: "input has-text-right ml-3",
                                attrs: {
                                  "data-target": "markupValue",
                                  title: "Sell Price: " + item.markupValue,
                                  min: 0,
                                  precision: 2,
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    return _vm.handleOnPriceChange(item)
                                  },
                                },
                                model: {
                                  value: item.markupValue,
                                  callback: function ($$v) {
                                    _vm.$set(item, "markupValue", _vm._n($$v))
                                  },
                                  expression: "item.markupValue",
                                },
                              })
                            : _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        item.markupValue,
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                        ],
                        1
                      ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            content: _vm.getStatus(item)?.tooltip,
                            enabled: !!_vm.getStatus(item)?.tooltip,
                            placement: "bottom",
                          },
                          expression:
                            "{ content: getStatus(item)?.tooltip, enabled: !!getStatus(item)?.tooltip, placement: 'bottom' }",
                        },
                      ],
                      staticClass: "left",
                      on: {
                        click: (e) =>
                          _vm.getStatus(item)?.isPartsCheckRouteEnabled
                            ? _vm.goToPartsCheck(
                                e,
                                item?.partsCheckReferenceNo,
                                "quote",
                                item
                              )
                            : e.stopPropagation(),
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "columns has-text-weight-bold ml-1",
                          class: [
                            _vm.getStatus(item)?.colour,
                            {
                              "is-clickable":
                                _vm.getStatus(item)?.isPartsCheckRouteEnabled,
                            },
                          ],
                          staticStyle: { width: "100%" },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.getStatus(item)?.title,
                                    enabled: !!_vm.getStatus(item)?.title,
                                  },
                                  expression:
                                    "{ content: getStatus(item)?.title, enabled: !!getStatus(item)?.title }",
                                },
                              ],
                              staticClass: "column is-justify-content-center",
                              on: {
                                click: function ($event) {
                                  _vm.getStatus(item)?.func()
                                },
                              },
                            },
                            [
                              _c("span", {
                                class: [_vm.getStatus(item)?.classStatus],
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      false
        ? _c("template", { slot: "footer" }, [
            _c(
              "div",
              {
                staticClass: "button mr-2 is-primary is-outlined",
                on: {
                  click: function ($event) {
                    return _vm.handleAddItem(_vm.ItemCategoryTypes.PART)
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                ]),
                _c("span", [_vm._v("Add Part")]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "button mr-2 is-primary is-outlined",
                on: {
                  click: function ($event) {
                    return _vm.handleAddItem(_vm.ItemCategoryTypes.SUBL)
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                ]),
                _c("span", [_vm._v("Add Sublet")]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "button mr-2 is-primary is-outlined",
                on: {
                  click: function ($event) {
                    return _vm.handleAddItem(_vm.ItemCategoryTypes.MISC)
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                ]),
                _c("span", [_vm._v("Add Misc")]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }